import React from "react";

export default function LoadingOrEmpty({ items, loadingText, emptyText, children }) {
  if (items === null) {
    return (
      <div className="loading-msg">
        <span className="spinner"></span> {loadingText}
      </div>
    );
  }
  if (!items.length) {
    return <p style={{ color: "var(--text-muted)", fontSize: "0.9rem" }}>{emptyText}</p>;
  }
  return children;
}
